import * as React from 'react';
import { SVGProps } from 'react';
import { useTheme } from '@mui/material/styles';

const Logo = (props: any) => {
    const {color = '#ffffff', ...rest} = props;
    const theme = useTheme();
    return (
        <img src="/logo_l.png" height="26px" {...rest} />
    );
};

export default Logo;